import React, {Component} from 'react';

class FeasibilityStudy extends Component{

    componentDidMount() {
        
      }
      
    render(){
        return(
            
        <div className="feasibility-study">
            <div className="overlay">
                <div className="container">
                    <div className="d-flex justify-content-end">
                        <div className="content wow fadeInDown">
                            <p className="subtitle">الرئيسية / غير مصنف / دراسة جدوى أولية</p>
                            <h3 className="title">دراسة جدوى أولية</h3>
                            <p className="price"> 1,200.00<span> ر.س </span></p><a className="main-btn" href="/home/package">إبدأ الأن</a>
                        </div>
                    </div>
                </div>   
            </div> 
        </div>
        )
    }

};
export default FeasibilityStudy;
